import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import RainbowButton from "../shared/RainbowButton";
import { isEventPast } from "../../shared/helpers";
import { useData } from "../../providers/dataProvider";
import "./EventDetails.css";

export default function EventDetails({ preview = false }) {
  const { id } = useParams();
  const eventId = parseInt(id);
  const { events, images } = useData();

  const [imageUrl, setImageUrl] = useState(null);

  // Find the event with the matching id
  const event = events.find((event) => event.id === eventId);
  useEffect(() => {
    const getImageUrl = async () => {
      const image_id = event?.image_id;
      if (image_id) {
        try {
          const image = images.find((i) => i.id === image_id);
          setImageUrl(image.aws_location);
        } catch (error) {
          console.error("Error loading image:", error);
        }
      }
    };

    getImageUrl();
  }, [event, images]);

  // Handle case where event is not found
  if (!event) {
    return (
      <div className="event-details-page-container">
        <div className="event-details-brick-background"></div>
        <div className="event-details-content-section">
          <Container>
            <div className="event-not-found-card">
              <h2>Event Not Found</h2>
              <p>Sorry, the event you're looking for doesn't exist.</p>
              <Link to="/events">
                <RainbowButton text="← Back to Events" />
              </Link>
            </div>
          </Container>
        </div>
      </div>
    );
  }

  // Handle case where event is not found
  if (isEventPast(event)) {
    return (
      <div className="event-details-page-container">
        <div className="event-details-brick-background"></div>
        <div className="event-details-content-section">
          <Container>
            <div className="event-not-found-card">
              <h2>Event Has Passed</h2>
              <p>Sorry we missed you, stay tuned for our upcoming events!</p>
              <Link to="/events">
                <RainbowButton text="← Back to Events" />
              </Link>
            </div>
          </Container>
        </div>
      </div>
    );
  }

  return (
    <div className="event-details-page-container">
      <div className="event-details-brick-background"></div>

      <div className="event-details-content-section">
        <Container>
          {!preview && (
            <div className="back-button-container">
              <Link to="/events">
                <Button className="back-button">← Back to Events</Button>
              </Link>
            </div>
          )}

          <div className="event-details-main-card">
            <Row>
              <Col md={6} className="mb-4">
                <img
                  src={imageUrl}
                  alt={event.title}
                  className="img-fluid event-details-image"
                  style={{
                    maxHeight: "400px",
                    objectFit: "cover",
                    width: "100%",
                  }}
                />
              </Col>
              <Col md={6}>
                <div className="d-flex align-items-start mb-4">
                  <div className="event-date-box text-center me-3">
                    <div className="event-date-month">{event.month}</div>
                    <div className="event-date-day">{event.day}</div>
                    <div className="event-date-year">{event.year}</div>
                  </div>
                  <div className="flex-grow-1">
                    <h1 className="event-title">{event.title}</h1>
                    <div className="event-short-description">{event.short_description}</div>
                  </div>
                </div>

                <div className="event-details-content">
                  <h4>Time and Location:</h4>
                  <div className="event-time-location">
                    <p>
                      <strong>{event.month} {event.day}, {event.year}</strong> at <strong>{event.time}</strong>
                      <br />
                      {event.location}
                      {event.address && (
                        <>
                          <br />
                          {event.address}
                        </>
                      )}
                    </p>
                  </div>

                  <h4>About The Event:</h4>
                  <div className="event-markdown-content">
                    <ReactMarkdown>{event.description}</ReactMarkdown>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
}
